export default function Loader({ error }) {
  return (
    <div className="loader-shell">
      <p className="mono-label">{error ? 'Archive interrupted' : 'Building visual sequence'}</p>
      <h1>{error || 'Stefan Maldet'}</h1>
      {!error && <div className="loader-bar" aria-hidden="true" />}
    </div>
  );
}
